import React from 'react';
import MainLayout from '../templates/MainLayout';

const HomePage: React.FC = () => <MainLayout />;

export default HomePage;
